
import './App.css';
import ShuffleHero from './components/Home/Hero';
import Navbar from './components/Home/Navbar';
import CompRoutes from './route';

function App() {
  return (
    <div> 
      <Navbar/>      
      <CompRoutes/>
    </div>
  );
}

export default App;
